import cx from "classnames";

import styles from "./ButtonGroup.module.scss";

interface ButtonGroupProps {
  children: React.ReactNode;
  className?: string;
}

const ButtonGroup = ({ children, className }: ButtonGroupProps) => {
  return <div className={cx(styles.buttons, className)}>{children}</div>;
};

export default ButtonGroup;
